export type SubTicketDueWarningKind = 'past' | 'after_parent_deadline';

export interface SubTicketDueWarning {
    kind: SubTicketDueWarningKind;
    message: string;
}

export interface ResolveDueWarningParams {
    dueAt: string | null;
    parentDeadlineAt: string | null;
    nowMs: number;
}

// A due date that has already passed, or that lands after the parent Request's own deadline,
// is worth stopping on — but it is a **confirmation, never a block**. Managers legitimately
// back-date a phase they are recording after the fact, and legitimately plan one past the
// client deadline; refusing either would push that work outside the tool entirely.
export const resolveDueWarning = ({
    dueAt,
    parentDeadlineAt,
    nowMs,
}: ResolveDueWarningParams): SubTicketDueWarning | null => {
    if (!dueAt) {
        return null;
    }

    const dueAtMs = Date.parse(dueAt);
    if (!Number.isFinite(dueAtMs)) {
        return null;
    }

    if (Number.isFinite(nowMs) && dueAtMs < nowMs) {
        return {
            kind: 'past',
            message: 'The due date you picked is already in the past.',
        };
    }

    if (parentDeadlineAt) {
        const parentDeadlineAtMs = Date.parse(parentDeadlineAt);

        if (Number.isFinite(parentDeadlineAtMs) && dueAtMs > parentDeadlineAtMs) {
            return {
                kind: 'after_parent_deadline',
                message: 'The due date you picked is after the deadline of the parent Request.',
            };
        }
    }

    return null;
};
